import { NoRefFields, pageCollectionFields } from 'drapcode-constant';
import { getCollectionFields } from '../../pluginComponentApi';

export const AutoCompleteInputBlock = (bm, category, labels, types) => {
  const style = `
  <style>
  .autocomplete-items div {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
  }
  div[data-gjs-type="${types.autocompleteInputContainer}"] {
    padding: 5px;
  }
  </style>
`;
  bm.add(types.autocompleteInputContainer, {
    label: `
    <i class="webconnect-menu-button-wide"></i><div>${labels.autocompleteInput}</div>`,
    category,
    content: `
    <div class="${types.autocompleteInputContainer}" data-gjs-type="${types.autocompleteInputContainer}" gjs-type="${types.autocompleteInputContainer}">
      <input name="myInput" placeholder="My Input" class="form-control" type="text" gjs-type="${types.autocompleteInput}"/>
    </div>${style}
    `,
    render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info no-doc">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/forms-component-form" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
      labels.autocompleteInput
    }?"></i>
          </a>
        </span>
      `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { collections, projectId, pageCollection } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          projectId: projectId,
          icon: '<i class="wb webconnect-menu-button-wide"></i>',
          'custom-name': label,
          collectionName: '',
          traits: [...dc.getType('default').model.prototype.defaults.traits],
          script: function () {
            const projectId = '{[ projectId ]}';
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';
            const fieldName = '{[ fieldName ]}';
            if (typeof renderAutoCompleteInput !== 'undefined') {
              renderAutoCompleteInput(this, collectionId, finderId, fieldName);
            }
          },
        },
        async init() {
          const finder = this.get('finderUuid');
          const fieldName = this.get('fieldName');
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });
          let collection = collections.find(
            (collection) => collection.collectionName === collectionName,
          );

          this.addTrait(
            [
              {
                type: 'select',
                label: 'Collection',
                name: 'collectionName',
                changeProp: 1,
                options,
                value: collectionName,
              },
              {
                type: 'select',
                label: 'Filter',
                name: 'finderUuid',
                changeProp: 1,
                value: finder,
              },
              {
                type: 'select',
                label: 'Auto Complete Field',
                name: 'fieldName',
                changeProp: 1,
                value: fieldName,
              },
            ],
            { at: 0 },
          );
          if (collection) {
            const finders = collection.finders;
            const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
            const finderOptions = finders.map((finder) => {
              return { value: finder.uuid, name: finder.name };
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            const fieldOptions = collection.fields
              .filter((field) => NoRefFields.includes(field.type))
              .map((field) => ({ value: field.fieldName, name: field.fieldTitle.en }));
            this.getTrait('fieldName').set({ options: fieldOptions });

            if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
              let pageCollectionOptions = pageCollection ? pageCollection.options : [];
              pageCollectionOptions = pageCollectionOptions.filter((opt) =>
                pageCollectionFields.includes(opt.type),
              );
              const externalQueryParamKeys = [];
              if (selectedFinder.conditions) {
                selectedFinder.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const {
                      query: { value },
                    } = condition;
                    if (value.includes('---')) {
                      const values = value.split('---');
                      externalQueryParamKeys.push(values[0]);
                      externalQueryParamKeys.push(values[1]);
                    } else {
                      externalQueryParamKeys.push(value);
                    }
                  }
                });
              }

              if (externalQueryParamKeys.length > 0) {
                externalQueryParamKeys.forEach((extParam) => {
                  this.addTrait({
                    name: extParam,
                    label: extParam,
                    options: pageCollectionOptions,
                    title: extParam,
                    type: 'finder-query-param-trait',
                  });
                });
              }
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          const attrs = this.getAttributes();
          attrs['selectedCollectionData'] = collection;
          this.setAttributes(attrs);

          if (collection) {
            const finderOptions = [];
            collection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            const fieldOptions = collection.fields
              .filter((field) => NoRefFields.includes(field.type))
              .map((field) => ({ value: field.fieldName, name: field.fieldTitle.en }));
            this.getTrait('fieldName').set({ options: fieldOptions });
          }
        },
        async handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.forEach((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              pageCollectionFields.includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:fieldName', this.updateScript);
      },
    }),
  });
};
